export default "__VITE_ASSET__BJEPI0jd__"